import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import { Navbar, Nav } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import authService from "./services/authService";
import LoginForm from "./components/LoginForm";
import { Switch, Route, Redirect, HashRouter } from "react-router-dom";
import ERecept from "./components/ERecept/ERecept";
import NotFound from "./components/common/NotFound";
import HomePage from "./components/common/HomePage";
import Casovani from "./components/Casovani/Casovani";
import HouseKeeping from "./components/Housekeeping/Housekeeping";
import CovidBooking from "./components/Covid/CovidBooking";
import { NavDropdown } from "react-bootstrap";
import Uzivatele from "./components/Sprava/Uzivatele";
import CasovaniDochazka from "./components/Casovani/CasovaniDochazka";
import config from "./config.json";
import FirmyVypis from "./components/Firmy/FirmyPrehled";
import OrdinacePrehled from "./components/Ordinace/OrdinacePrehled";
import CovidKalendar from "./components/Covid/CovidKalendar";
import NovinkyAdmin from "./components/Novinky/NovinkyAdmin";
import Praxe from "./components/Praxe/Praxe";
import MajetekVypis from "./components/Majetek/MajetekVypis";
import KartaKlienta from "./components/Casovani/KartaKlienta";

function App() {
  let user = authService.getCurrentUser();
  return (
    <React.Fragment>
      <ToastContainer />
      {user && user.login ? (
        <React.Fragment>
          <Navbar bg="light" expand="lg">
            <div className="container">
              <Navbar.Brand href="/">
                <img src={config.logo} style={{ height: "32px" }} />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                  {user.admin === "1" && (
                    <NavDropdown title="Správa">
                      <NavDropdown.Item href="#/sprava/uzivatele">
                        Uživatelé
                      </NavDropdown.Item>
                      <NavDropdown.Item href="#/sprava/kalendar-testovani">
                        Kalendář testování
                      </NavDropdown.Item>
                      <NavDropdown.Item href="#/sprava/firmy">
                        Zaměstnavatelé/Firmy
                      </NavDropdown.Item>
                      <NavDropdown.Item href="#/sprava/ordinace">
                        Testovací místa
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}
                  {/*user.erecept === "1" && (
                    <Nav.Link href="#/e-recept">E-recept</Nav.Link>
                  )*/}
                  {user.casovani === "1" && (
                    <Nav.Link href="https://lbis.laznetrebon.cz/LBIS_L4WebApp/">
                      Časování
                    </Nav.Link>
                  )}
                  {/*user.housekeeping === "1" && (
                    <Nav.Link href="#/housekeeping">Housekeeping</Nav.Link>
                  )*/}
                  <Nav.Link href="#/covid">Covid</Nav.Link>
                  {config.lazne && <Nav.Link href="#/praxe">Praxe</Nav.Link>}
                  {config.lazne && (
                    <Nav.Link href="#/majetek">Majetek</Nav.Link>
                  )}
                  {(user.admin === "1" || user.novinky === "1") && (
                    <Nav.Link href="#/novinky-admin">Novinky</Nav.Link>
                  )}
                </Nav>
                <div>
                  {user && user.jmeno}
                  <button
                    className="btn btn-primary"
                    style={{ marginLeft: "20px" }}
                    onClick={() => {
                      authService.logout();
                      window.location = "/";
                    }}
                  >
                    Odhlásit
                  </button>
                </div>
              </Navbar.Collapse>
            </div>
          </Navbar>
          <div className="container" style={{ paddingTop: "20px" }}>
            <HashRouter>
              <Switch>
                <Route path="/sprava/uzivatele" component={Uzivatele} />
                <Route path="/sprava/firmy" component={FirmyVypis} />
                <Route path="/sprava/ordinace" component={OrdinacePrehled} />
                <Route
                  path="/sprava/kalendar-testovani"
                  component={CovidKalendar}
                />
                <Route path="/e-recept" component={ERecept} />
                <Route path="/casovani/dochazka" component={CasovaniDochazka} />
                <Route
                  path="/casovani/kartaKlienta/:idpobytu"
                  component={KartaKlienta}
                />
                <Route path="/casovani/kartaKlienta" component={KartaKlienta} />
                <Route path="/casovani" component={Casovani} />
                <Route path="/housekeeping" component={HouseKeeping} />
                <Route path="/covid" component={CovidBooking} />
                <Route path="/praxe" component={Praxe} />
                <Route path="/novinky-admin" component={NovinkyAdmin} />
                <Route path="/not-found" component={NotFound} />
                <Route path="/majetek" component={MajetekVypis} />
                <Route path="/" exact component={HomePage} />
                <Redirect to="/not-found" />
              </Switch>
            </HashRouter>
          </div>
        </React.Fragment>
      ) : (
        <LoginForm />
      )}
    </React.Fragment>
  );
}

export default App;
